import { DocsIncluded } from './docs-included.model';
export class DocsIncludedResponse {
    response: DocsIncluded[];
    errorCode: any;
    errorDescription: string;
    errorMessage: string;
}
